<template>
    <section
        class="ProductGrid my-medium"
    >
        <div class="container">
            <slot>
                <BaseHeading
                    v-if="heading"
                    :heading="heading"
                    :preheading="preheading"
                    tag="h2"
                />
            </slot>
            <div class="grid grid--medium">
                <div
                    v-for="(item, index) in entriesOnPage"
                    :key="index"
                    class="grid__item smart-one-whole one-half lap-and-up-one-third"
                >
                    <ProductCard
                        :product="item"
                        :hide-desc="hideDesc"
                        :show-features="showFeatures"
                        :subcategory="item[subcategory]"
                        :class="cardStyle"
                        :truncate-text="true"
                    />
                </div>
            </div>
            <HrLine
                v-if="paginate && items.length > load"
            />
            <BaseButton
                v-if="paginate && items.length > load"
                @click="load += paginate"
            >
                Load More
            </BaseButton>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ProductGrid',
    props: {
        items: {
            type: Array,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        hideDesc: {
            type: Boolean,
            default: false
        },
        showFeatures: {
            type: Boolean,
            default: false
        },
        subcategory: {
            type: String,
            default: null
        },
        flexCard: {
            type: Boolean,
            default: false
        },
        load: {
            type: Number,
            default: 3
        },
        paginate: {
            type: Number,
            default: null
        },
    },
    computed: {
        entriesOnPage: function ()  {
            return this.items.slice(0, this.load);
        },
        cardStyle() {
            return this.flexCard ? 'ProductCard--flex' : null
        }
    }
}
</script>
<style lang="scss" scoped>
    .ProductCard {
        display: block;
        margin: getSpacing('medium') / 2 0;

        @include media-query('lap-and-up') {
            margin: getSpacing('large') / 2 0;
        }

        .grid__item:last-child & {
            margin-bottom: 0!important;
        }

        .BaseButton {
            display: block;
            margin: auto;
            width: 225px;
            cursor: pointer;
            margin-bottom: getSpacing('xlarge');
        }
    }

    .ProductCard--flex {
        @include media-query(smart) {
            display: flex;
            border-bottom: 1px solid getColour('grey', 'medium');
            margin-bottom: 0.5rem;

            .grid__item:last-child & {
                border-bottom: 0;
            }
        }
    }

    .BaseHeading {
        text-align: center;
        margin-bottom: getSpacing('small');

        @include media-query(desk) {
            margin-bottom: getSpacing('base');
        }
    }

    .HrLine {
        padding-left: 0;
        padding-right: 0;
        margin-bottom: getSpacing('large');


        @include media-query(lap-and-up) {
            margin-top: getSpacing('medium');
        }
    }

    .BaseButton {
        display: block;
        margin: auto;
        width: 150px;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        cursor: pointer;
        margin-top: getSpacing('large');
    }
</style>
